import React from "react";
import { MessageCircle, Phone, FileText } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { withLocale } from "@/lib/seo";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

const WA = "971565248900";
const TEL = "+971565248900";

export const LeadCTA = ({ service }) => {
  const { t, lang, isAr } = useLang();
  const navigate = useNavigate();
  const waText = encodeURIComponent(isAr ? `مرحباً، أرغب بالاستفسار عن: ${service || "خدماتكم"}` : `Hello, I'd like to enquire about: ${service || "your services"}`);
  return (
    <div className="rounded-2xl bg-navy-deep text-white p-6 sm:p-8 my-10" data-testid="lead-cta">
      <h3 className="font-display text-xl sm:text-2xl">{t({ en: "Need help from an Approved Tax Agent?", ar: "تحتاج مساعدة من وكيل ضريبي معتمد؟" })}</h3>
      <p className="mt-2 text-white/70">{t({ en: "Talk to us on WhatsApp, call directly, or request a tailored quote in minutes.", ar: "تحدّث معنا عبر واتساب، أو اتصل مباشرة، أو اطلب عرض سعر مخصّص." })}</p>
      <div className="mt-5 flex flex-wrap gap-3">
        <a href={`https://wa.me/${WA}?text=${waText}`} target="_blank" rel="noopener" onClick={() => trackEvent("whatsapp_click", { service })} data-testid="cta-whatsapp"
          className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-brandgreen text-white font-semibold hover:bg-brandgreen-600 transition-colors"><MessageCircle className="h-5 w-5" /> {t({ en: "WhatsApp", ar: "واتساب" })}</a>
        <a href={`tel:${TEL}`} onClick={() => trackEvent("call_click", { service })} data-testid="cta-call"
          className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-white text-navy font-semibold hover:bg-white/90 transition-colors"><Phone className="h-5 w-5" /> {t({ en: "Call", ar: "اتصال" })}</a>
        <button onClick={() => { trackEvent("quote_request", { service }); navigate(withLocale(lang, "/packages")); }} data-testid="cta-quote"
          className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-crimson text-white font-semibold hover:bg-crimson-600 transition-colors"><FileText className="h-5 w-5" /> {t({ en: "Request a quote", ar: "اطلب عرض سعر" })}</button>
      </div>
    </div>
  );
};

export const StickyMobileCTA = () => {
  const { t, isAr } = useLang();
  const waText = encodeURIComponent(isAr ? "مرحباً، أرغب بالاستفسار" : "Hello, I'd like to enquire");
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-line grid grid-cols-2 gap-2 p-2.5" data-testid="sticky-mobile-cta">
      <a href={`https://wa.me/${WA}?text=${waText}`} target="_blank" rel="noopener" onClick={() => trackEvent("whatsapp_click", { source: "sticky" })}
        className="inline-flex items-center justify-center gap-2 h-11 rounded-full bg-brandgreen text-white font-semibold text-sm"><MessageCircle className="h-4 w-4" /> {t({ en: "WhatsApp", ar: "واتساب" })}</a>
      <a href={`tel:${TEL}`} onClick={() => trackEvent("call_click", { source: "sticky" })}
        className="inline-flex items-center justify-center gap-2 h-11 rounded-full bg-navy text-white font-semibold text-sm"><Phone className="h-4 w-4" /> {t({ en: "Call now", ar: "اتصل الآن" })}</a>
    </div>
  );
};
